<template>
  <section>
    <LmComponentLoading v-if="isLoading" />
    <div v-if="EChartSettings">
      <v-chart class="chart" :option="EChartSettings" :init-options="initOptions" />
    </div>
    <div v-else>
      <LmSvgIcon
        v-if="error"
        wrapperClass="d-flex h-100 justify-content-center align-items-center flex-column"
        width="12em"
        icon="LmErrorIcon"
        text="No pudimos cargar el Widget."
      />
      <template v-else>
        <h4>Configura tu gráfico</h4>
        <p>Comienza a configurar tu gráfico desde el panel izquierdo para poder visualizarlo aquí mismo.</p>
      </template>
    </div>
  </section>
</template>

<script>
// Component
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { PieChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'
import 'zrender/lib/svg/svg'

// Utils
import commonsApi from '@/api/commons'

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent
])

export default {
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: 'ligth'
  },
  props: {
    widget: {
      type: Object
    },
    customization: {
      type: Object
    },
    hideTitle: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      error: false,
      isLoading: false,
      EChartSettings: null,
      initOptions: {
        renderer: 'svg'
      }
    }
  },
  methods: {
    checkSize (size) {
      // Agrega retrocompatibilidad en size, size por defecto es 10
      if (!size) {
        size = 10
      }
      return size
    },
    renderData (data) {
      const title = this.widget.title || this.widget.datatableAlias
      this.EChartSettings = {
        tooltip: {},
        legend: {
          orient: 'vertical',
          left: 'left',
          top: 30,
          data: data.map(el => el.name)
        },
        series: [
          {
            name: title,
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      if (!this.hideTitle) {
        this.EChartSettings.title = {
          text: title,
          left: 'center'
        }
      }
    },
    async loadData (datatable, term, size) {
      try {
        this.isLoading = true
        this.error = false
        const res = await commonsApi.axiosPostWrapper('/widgets/generate-chart', {
          id: datatable.id,
          term: term,
          size: this.checkSize(size)
        })

        if (!this.widget.title) {
          this.widget.title = res.data.title
        }

        this.renderData(res.data.items)
      } catch (error) {
        console.log(error)
        this.EChartSettings = null
        this.error = true
      } finally {
        this.isLoading = false
      }
    }
  },
  watch: {
    widget: {
      deep: true,
      async handler (val) {
        if (val.aggTerm && val.dataOrigin) {
          await this.loadData(val.dataOrigin, val.aggTerm, val.size)
        } else {
          this.EChartSettings = null
        }
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      if (this.widget.dataOrigin && this.widget.aggTerm) {
        await this.loadData(this.widget.dataOrigin, this.widget.aggTerm, this.widget.size)
      } else {
        this.EChartSettings = null
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style scoped>
.chart {
  height: 400px;
}
</style>
